<app-dialog-header title="Solicitar reembolso?" />
<mat-dialog-content class="refund-request-modal__content">
  <p class="refund-request-modal__message">
    Sua solicitação será avaliada automaticamente conforme as regras de reembolso. Se estiver tudo certo, a aprovação
    será automática. Você poderá acompanhar o resultado em suas solicitações.
  </p>
  <label for="refund-customer-reason" class="refund-request-modal__label">Motivo do reembolso</label>
  <!-- maxlength counts UTF-16 units; the validator and counter count Unicode codepoints. -->
  <textarea
    id="refund-customer-reason"
    class="form-control"
    rows="4"
    required
    [attr.maxlength]="maxReasonLength * 2"
    [formControl]="reason"
    [attr.aria-invalid]="reason.touched && reason.invalid"
    [attr.aria-describedby]="
      reason.touched && reason.invalid ? 'refund-reason-hint refund-reason-error' : 'refund-reason-hint'
    "
    placeholder="Conte por que você está solicitando o reembolso"></textarea>
  <p id="refund-reason-hint" class="refund-request-modal__hint">
    O motivo será registrado como um comentário na sua solicitação.
    <span class="d-block" aria-live="polite"
      >{{ reasonLength }} / {{ maxReasonLength }} caracteres (mínimo {{ minReasonLength }}).</span
    >
  </p>
  @if (reason.touched && reason.invalid) {
    <p id="refund-reason-error" class="refund-request-modal__error" role="alert">
      Informe o motivo do reembolso com 15 a 1.000 caracteres.
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="refund-request-modal__actions">
  <app-button styleType="outlined" (btnClick)="dialogRef.close()">Cancelar</app-button>
  <app-button [disabled]="reason.invalid" (btnClick)="submit()">Solicitar reembolso</app-button>
</mat-dialog-actions>
